/* global $, LANG, Modernizr */

const $navbar = $('.js-navbar');
const $navbarList = $('.js-nav-list');
const $navbarWrapper = $('.js-nav-wrapper');
const $navbarItems = $navbarWrapper.find('.js-nav-list > .nav-item');
const $toggler = $('.js-navbar-toggler');
const TOGGLER_TEXT_CLASS = '.navbar-toggler__text';

const navigation = {
  initialize() {
    if ($navbar.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $toggler.on('click', (e) => {
      e.preventDefault();

      const isOpen = $toggler.hasClass('is-open');
      const text = $toggler.find(TOGGLER_TEXT_CLASS);

      $toggler.toggleClass('is-open', !isOpen);

      if (isOpen) {
        $navbarWrapper.css('height', 0);
        this.moveListToX('0');
        text.html(LANG.menu);
      } else {
        text.html(LANG.close);
      }
    });

    if (Modernizr.mq('(max-width: 991px)')) {
      $navbar.on('click', '.js-has-dropdown > a', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $dropdown = $(e.currentTarget).parent().find('.js-dropdown');

        this.toggleDropdown($dropdown);
      });

      $navbar.on('click', '.js-dropdown-back', (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.moveListToX('0');
        this.changeListHeight($navbarItems);
      });
    }
  },

  toggleDropdown($dropdown) {
    $('.js-dropdown').removeClass('is-open');
    $dropdown.addClass('is-open');
    const $listItems = $dropdown.find('.js-dropdown-item');

    this.moveListToX('-100%');
    this.changeListHeight($listItems);
  },

  moveListToX(x) {
    $navbarList.css({
      webkitTransform: `translateX(${x})`,
      msTransform: `translateX(${x})`,
      transform: `translateX(${x})`,
    });
  },

  changeListHeight($items) {
    const navHeight = this.getListHeight($items);
    $navbarWrapper.css('height', navHeight);
  },

  getListHeight($items) {
    const innerWidth = $navbarWrapper.find($items).toArray().reduce((accumulator, child) => (
      accumulator + $(child).innerHeight()
    ), 0);

    $navbarWrapper.css('height', innerWidth);
  },
};

export default navigation;
